import { render } from "./LoginLayout.vue?vue&type=template&id=dbd5b94c&scoped=true"
const script = {}

import "./LoginLayout.vue?vue&type=style&index=0&id=dbd5b94c&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd5b94c"]])

export default __exports__